import {
  REACT_DELIVERY_REPORT,
  REACT_DEVICE_COMMANDS,
  REACT_OPERATION_LOGS,
  REACT_PRE_REGISTRATION_LIST,
  REACT_PRE_REGISTRATION_REPORT_LIST,
  REACT_SELF_REGISTRATION_LIST,
  REACT_URL_ADDRESSTYPE,
  REACT_URL_APPROVAL,
  REACT_URL_BLACKLISTVISITORS,
  REACT_URL_BLOCKED_VISITORS,
  REACT_URL_CHECKINOUTDEVICES,
  REACT_URL_CHECKLIST,
  REACT_URL_DAILYREPORT,
  REACT_URL_DASHBOARD,
  REACT_URL_INVITATIONREPORT,
  REACT_URL_INVITATIONS,
  REACT_URL_PERSON,
  REACT_URL_PURPOSETYPE,
  REACT_URL_REGISTRATIONS,
  REACT_URL_RESTRICTTYPE,
  REACT_URL_ROLE,
  REACT_URL_SELFREGISTRATIONREPORT,
  REACT_URL_SITE,
  REACT_URL_SITETYPE,
  REACT_URL_USER_LIST,
  REACT_URL_VISITINVITE,
  REACT_URL_WALKINREGISTRATIONREPORT,
  REACT_URL_WALKINVISIT,
  REACT_URL_WATCHLIST,
} from "../../actions/EndPoints";
import { ReactComponent as Dashboard_Icon } from "../../assets/images/dashboard-icons/dashboard_icon.svg";
import vis_Organization_Icon from "../../assets/images/dashboard-icons/OrganizationGray";
import vis_Device_Icon from "../../assets/images/dashboard-icons/SettingsGray";
import vis_SiteManagement from "../../assets/images/dashboard-icons/Sitemanagementgray2";
import vis_visitor_icon from "../../assets/images/dashboard-icons/VisitorGray";
import vis_Dashboard_Icon from "../../assets/USA_Images/navitem_images/Dashboard";
import Organization_Icon from "../../assets/USA_Images/navitem_images/OrganizationWhite";
import ReportIcon from "../../assets/USA_Images/navitem_images/ReportIcon";
import Device_Icon from "../../assets/USA_Images/navitem_images/settingWhite";
import SiteManagement from "../../assets/USA_Images/navitem_images/SiteManagementWhite";
import visitor_icon from "../../assets/USA_Images/navitem_images/VisitorWhite";
import BrowserLanguage from "../../components/Util/BrowserLanguage";

let language = BrowserLanguage.getDefaultLanguage();
const dataEn = [
  {
    id: "0",
    name: "Dashboard",
    link: `${REACT_URL_DASHBOARD}`,
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? vis_Dashboard_Icon
        : Dashboard_Icon,
  },
  {
    id: "1",
    name: "Visitors",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? visitor_icon
        : vis_visitor_icon,
    items: [
      {
        id: "2",
        name: "Invitations",
        link: `${REACT_URL_VISITINVITE}`,
      },

      {
        id: "3",
        name:
          process.env.REACT_APP_ENVIRONMENT === "USA"
            ? "Walk-In Registrations"
            : "Registrations",
        link: `${REACT_URL_WALKINVISIT}`,
      },
      {
        id: "6",
        name: "Self Registrations",
        link: `${REACT_SELF_REGISTRATION_LIST}`,
      },

      {
        id: "7",
        name: "Pre Registrations",
        link: `${REACT_PRE_REGISTRATION_LIST}`,
      },

      {
        id: "4",
        name: "Approvals",
        link: `${REACT_URL_APPROVAL}`,
      },

      {
        id: "5",
        name: "Blocklist Visitor",
        link: `${REACT_URL_BLACKLISTVISITORS}`,
      },
    ],
  },

  //
  {
    id: "19",
    name: "Reports",
    Icon: ReportIcon,
    items: [
      {
        id: "20",
        name: "Daily Reports",
        link: `${REACT_URL_DAILYREPORT}`,
      },
      {
        id: "21",
        name: "Invitations",
        link: `${REACT_URL_INVITATIONREPORT}`,
      },
      {
        id: "22",
        name: "Walk-In Registrations",
        link: `${REACT_URL_WALKINREGISTRATIONREPORT}`,
      },
      {
        id: "23",
        name: "Self Registrations",
        link: `${REACT_URL_SELFREGISTRATIONREPORT}`,
      },
      {
        id: "36",
        name: "Pre Registrations",
        link: `${REACT_PRE_REGISTRATION_REPORT_LIST}`,
      },
      {
        id: "54",
        name: "Delivery Reports",
        link: `${REACT_DELIVERY_REPORT}`,
      },
      {
        id: "55",
        name: "Device Commands",
        link: `${REACT_DEVICE_COMMANDS}`,
      },
      {
        id: "56",
        name: "Operation Logs",
        link: `${REACT_OPERATION_LOGS}`,
      },
    ],
  },
];

const dataEs = [
  {
    id: "0",
    name: "Panel",
    link: `${REACT_URL_DASHBOARD}`,
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? vis_Dashboard_Icon
        : Dashboard_Icon,
  },
  {
    id: "5",
    name: "Visitante",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? visitor_icon
        : vis_visitor_icon,
    items: [
      {
        id: "20",
        name: "Invitaciones",
        link: `${REACT_URL_INVITATIONS}`,
      },
      {
        id: "3",
        name:
          process.env.REACT_APP_ENVIRONMENT === "USA"
            ? "Registro sin cita previa"
            : "Inscripciones",
        link: `${REACT_URL_WALKINVISIT}`,
      },
      {
        id: "7",
        name: "Preinscripciones",
        link: `${REACT_PRE_REGISTRATION_LIST}`,
      },
      {
        id: "23",
        name: "Auto registro",
        link: `${REACT_SELF_REGISTRATION_LIST}`,
      },
      {
        id: "24",
        name: "Aprobaciones",
        link: `${REACT_URL_APPROVAL}`,
      },
      {
        id: "25",
        name: "Visitantes bloqueados",
        link: `${REACT_URL_BLOCKED_VISITORS}`,
      },
    ],
  },
  {
    id: "5",
    name: "Informe",
    Icon: ReportIcon,
    items: [
      {
        id: "19",
        name: "Reporte diario",
        link: `${REACT_URL_DAILYREPORT}`,
      },
      {
        id: "20",
        name: "Invitación",
        link: `${REACT_URL_INVITATIONREPORT}`,
      },
      {
        id: "21",
        name: "Registro sin cita previa",
        link: `${REACT_URL_WALKINREGISTRATIONREPORT}`,
      },
      {
        id: "22",
        name: "Auto registro",
        link: `${REACT_URL_SELFREGISTRATIONREPORT}`,
      },
      {
        id: "36",
        name: "Preinscripciones",
        link: `${REACT_PRE_REGISTRATION_REPORT_LIST}`,
      },
      {
        id: "23",
        name: "Informe de entrega",
        link: `${REACT_DELIVERY_REPORT}`,
      },
      {
        id: "55",
        name: "Comandos de Dispositivos",
        link: `${REACT_DEVICE_COMMANDS}`,
      },
      {
        id: "56",
        name: "Registros de Operaciones",
        link: `${REACT_OPERATION_LOGS}`,
      },
    ],
  },
];

const dataZh = [
  {
    id: "0",
    name: "仪表板",
    link: `${REACT_URL_DASHBOARD}`,
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? vis_Dashboard_Icon
        : Dashboard_Icon,
  },
  {
    id: "5",
    name: "游客",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? visitor_icon
        : vis_visitor_icon,
    items: [
      {
        id: "20",
        name: "邀请函",
        link: `${REACT_URL_INVITATIONS}`,
      },
      {
        id: "21",
        name: "注册",
        link: `${REACT_URL_REGISTRATIONS}`,
      },
      {
        id: "22",
        name: "批准",
        link: `${REACT_URL_APPROVAL}`,
      },
      {
        id: "23",
        name: "被阻止的访客",
        link: `${REACT_URL_BLOCKED_VISITORS}`,
      },
    ],
  },
  {
    id: "1",
    name: "组织",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Organization_Icon
        : vis_Organization_Icon,
    items: [
      {
        id: "6",
        name: "人",
        link: `${REACT_URL_PERSON}`,
      },
      {
        id: "7",
        name: "角色",
        link: `${REACT_URL_ROLE}`,
      },
      {
        id: "8",
        name: "用户",
        link: `${REACT_URL_USER_LIST}`,
      },
    ],
  },
  {
    id: "2",
    name: "现场管理",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? SiteManagement
        : vis_SiteManagement,
    items: [
      {
        id: "10",
        name: "地址类型",
        link: `${REACT_URL_ADDRESSTYPE}`,
      },
      {
        id: "11",
        name: "网站类型",
        link: `${REACT_URL_SITETYPE}`,
      },
      {
        id: "12",
        name: "地点",
        link: `${REACT_URL_SITE}`,
      },
      {
        id: "12",
        name: "签入和签出设备",
        link: `${REACT_URL_CHECKINOUTDEVICES}`,
      },
    ],
  },
  {
    id: "3",
    name: "设置",
    Icon:
      process.env.REACT_APP_ENVIRONMENT === "USA"
        ? Device_Icon
        : vis_Device_Icon,
    items: [
      {
        id: "13",
        name: "用途类型",
        link: `${REACT_URL_PURPOSETYPE}`,
      },
      {
        id: "14",
        name: "限制类型",
        link: `${REACT_URL_RESTRICTTYPE}`,
      },
      {
        id: "15",
        name: "清单",
        link: `${REACT_URL_CHECKLIST}`,
      },
      {
        id: "16",
        name: "关注列表",
        link: `${REACT_URL_WATCHLIST}`,
      },
    ],
  },
];

export default language === "en" ? dataEn : language === "es" ? dataEs : dataZh;
